import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiTrash2 } from "react-icons/fi";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const DeleteVAPModal = ({
  deleteId,
  setDeleteId,
  type,
  fetchCourseContent,
}) => {
  const navigate = useNavigate();

 

  // Function to delete based on type
  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem("access_token");

      // Choose API link based on type
      let url = "";
      if (type === 2) {
        url = `${BASE_URL}/courses/video/${id}/delete/`;
      } else if (type === 3) {
        url = `${BASE_URL}/courses/audio/${id}/delete/`;
      }
      else if (type === 4) {
        url = `${BASE_URL}/courses/podcast/${id}/delete/`;
      }
       else {
        url = `${BASE_URL}/courses/course/module/lesson/${id}/delete/`;
      }

      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      });

      if (!response.ok) {
        throw new Error("Failed to delete");
      }
       alert(`${type === 2 ? "Video": type ===3 ? "Audio" : type == 4 ? "PodCast" : ''} Deleted Successfully`);
       setDeleteId(null);
      if (type === 2) {
        navigate("/teacher/videos");
      }
      else if(type === 3 )
      {
          navigate("/teacher/audios")
      }
      else if(type === 4)
      {
         navigate("/teacher/podcasts")
      }
       else {
        fetchCourseContent(); 
      }

    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  // Close modal when clicking outside
  const handleModalClick = (e) => {
    if (e.target === e.currentTarget) {
      setDeleteId(null);
    }
  };

  return (
   <div>
  {deleteId && (
    <div
      onClick={handleModalClick}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
    >
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
        
        {/* Header */}
        <div className="flex items-start gap-4">
          
          {/* Icon */}
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#e8f0f7]">
            <svg className="w-6 h-6 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </div>

          {/* Content */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              Delete {type === 2 ? "Video" : type === 3 ? "Audio" : type == 4 ? "PodCast" : ""}
            </h3>
            <p className="mt-1 text-sm text-gray-500">
              Are you sure you want to delete this{" "}
              {type === 2 ? "Video" : type === 3 ? "Audio" : type == 4 ? "PodCast" : ""}? This action cannot be undone.
            </p>
          </div>
        </div>

        {/* Actions */}
        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={() => setDeleteId(null)}
            className="px-4 py-2 text-sm font-medium text-gray-700 rounded-xl hover:bg-gray-100 transition-colors"
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={() => handleDelete(deleteId)}
            className="px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-xl hover:bg-red-600 transition-colors flex items-center gap-2"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
            Delete
          </button>
        </div>

      </div>
    </div>
  )}
</div>
  );
};

export default DeleteVAPModal;
